import { useNotification } from '../context/NotificationContext';

export default function ToastContainer() {
  const { notifications, removeNotification } = useNotification();

  const typeStyles = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800',
  };

  const typeIcons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };

  const typeColors = {
    success: 'text-green-600',
    error: 'text-red-600',
    warning: 'text-yellow-600',
    info: 'text-blue-600',
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-3 pointer-events-none">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className={`
            border rounded-lg p-4 shadow-lg flex items-start gap-3
            animate-in fade-in slide-in-from-top-4 duration-300
            max-w-sm pointer-events-auto
            ${typeStyles[notification.type]}
          `}
        >
          <span className={`text-lg font-bold flex-shrink-0 ${typeColors[notification.type]}`}>
            {typeIcons[notification.type]}
          </span>
          <p className="text-sm font-medium flex-1">
            {notification.message}
          </p>
          <button
            onClick={() => removeNotification(notification.id)}
            className="text-xs font-semibold opacity-60 hover:opacity-100 transition-opacity flex-shrink-0"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
